module.exports = __webpack_public_path__ + "img/etapas-title.ee7c05bc.svg";